export interface NewsItem {
  date: string;
  title: string;
  content: string;
  tags: string[];
}

export const newsItems: NewsItem[] = [
  {
    date: '22.11.2025',
    title: '🤖 AI Ассистент и Drag & Drop',
    content: 'Революционное обновление! Теперь вы можете обсуждать задачи и цели с AI помощником, создавать задачи и цели через естественный диалог, редактировать их и управлять всем проектом через умного ассистента. Реализован Drag & Drop для перемещения задач между колонками канбан-доски (Запланировано → В процессе → Сегодня → Сделано) и изменения порядка целей. Цели теперь с приоритетами (isPriority), задачи с точным временем выполнения (dueTime). Мгновенное обновление UI без перезагрузки страницы.',
    tags: ['AI', 'Drag & Drop', 'UX']
  },
  {
    date: '18.11.2025',
    title: '🚀 Запуск платформы AvatarMe!',
    content: 'Мы рады представить AvatarMe — комплексную систему управления жизнью. Теперь вы можете отслеживать финансы, цели, здоровье и семью в одном месте. Реализован мощный инструмент массового импорта задач: скопируйте список дел из любого источника, редактируйте в таблице, применяйте массовые изменения к целям, категориям и статусам. Идеально для переноса старых наработок с сохранением истории.',
    tags: ['Запуск', 'Анонс', 'Задачи']
  },
  {
    date: '15.11.2025',
    title: '📊 Модуль инвестиционного портфеля',
    content: 'Добавлен трекер инвестиционного портфеля с поддержкой акций, облигаций и валют. Цены активов обновляются автоматически через Yahoo Finance и Московскую биржу (MOEX). Отслеживайте прибыль/убыток в режиме реального времени.',
    tags: ['Финансы', 'Инвестиции']
  },
  {
    date: '10.11.2025',
    title: '🎯 Визуализация целей в виде дерева',
    content: 'Реализована интерактивная визуализация целей в виде дерева с поддержкой жизненных категорий, проектов, целей и подцелей. Перетаскивайте узлы, создавайте связи и управляйте иерархией целей интуитивно.',
    tags: ['Цели', 'UI/UX']
  },
  {
    date: '05.11.2025',
    title: '📋 Канбан-доска для задач',
    content: 'Каждая цель теперь имеет канбан-доску с колонками: Запланировано, В процессе, Готово, Архив. Перетаскивайте задачи между статусами и отслеживайте прогресс визуально.',
    tags: ['Задачи', 'Productivity']
  },
  {
    date: '01.11.2025',
    title: '📅 Архивирование с кастомной датой',
    content: 'Теперь при архивировании задачи можно указать дату фактического завершения. Это особенно полезно для импорта исторических данных и точной статистики за прошлые периоды.',
    tags: ['Задачи', 'Feature']
  },
  {
    date: '28.10.2025',
    title: '💰 Улучшен расчёт баланса',
    content: 'Исправлена логика расчёта баланса в разделе Финансы. Теперь баланс корректно показывает наличные средства как разницу между доходами и расходами.',
    tags: ['Финансы', 'Bugfix']
  },
  {
    date: '25.10.2025',
    title: '🔒 Усиление безопасности',
    content: 'Проведён аудит безопасности: добавлена защита от CSRF, усилен rate limiting, настроены CORS и Helmet для защиты от XSS-атак. Ваши данные надёжно защищены.',
    tags: ['Безопасность', 'Backend']
  },
  {
    date: '20.10.2025',
    title: '👨‍👩‍👧‍👦 Модуль "Семья"',
    content: 'Запущен раздел "Семья" для управления членами семьи, событиями и активностями. Отслеживайте дни рождения, годовщины и семейные цели.',
    tags: ['Семья', 'Feature']
  },
  {
    date: '15.10.2025',
    title: '🎨 Редизайн главной страницы',
    content: 'Обновлён дизайн лендинга с современным градиентом, анимациями и улучшенной читаемостью. Добавлены разделы FAQ и Новости для лучшего онбординга пользователей.',
    tags: ['UI/UX', 'Design']
  },
  {
    date: '10.10.2025',
    title: '📈 Статистика выполнения задач',
    content: 'Во вкладке "Статистика" раздела Целей теперь можно выбрать период и увидеть количество выполненных задач с группировкой по месяцам. Следите за своей продуктивностью!',
    tags: ['Аналитика', 'Цели']
  }
];

// Краткая версия для лендинга (последние 3 новости)
export const landingPageNews = newsItems.slice(0, 3).map(item => ({
  date: item.date,
  title: item.title,
  desc: item.content.split('.')[0] + '.'
}));
